"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_1 = tslib_1.__importDefault(require("react"));
const react_helmet_1 = tslib_1.__importDefault(require("react-helmet"));
const react_if_1 = require("react-if");
const react_router_dom_1 = require("react-router-dom");
const reactstrap_1 = require("reactstrap");
const react_2 = require("@osmosys/react");
exports.CenteredPage = ({ icon, iconPreset, title, buttonText, iconProps, buttonTo, children, }) => {
    icon =
        iconPreset === 'compass'
            ? pro_solid_svg_icons_1.faCompassSlash
            : iconPreset === 'warning'
                ? pro_solid_svg_icons_1.faCommentAltExclamation
                : icon;
    return (react_1.default.createElement(react_2.OsmosysDiv, { osysName: "CenteredPage", className: "flex-full-col-centered" },
        react_1.default.createElement("div", { className: "flex-row-centered" },
            react_1.default.createElement("div", { className: "text-center" },
                react_1.default.createElement(react_if_1.When, { condition: !!title },
                    react_1.default.createElement(react_helmet_1.default, { title: title })),
                icon && (react_1.default.createElement("h2", null,
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, Object.assign({ icon: icon }, iconProps)))),
                react_1.default.createElement(react_if_1.When, { condition: !!title },
                    react_1.default.createElement("h3", null, title)),
                react_1.default.createElement(react_if_1.When, { condition: !!(buttonTo && buttonText) },
                    react_1.default.createElement(reactstrap_1.Button, { tag: react_router_dom_1.Link, to: buttonTo, color: "primary" },
                        buttonText,
                        ' ',
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, Object.assign({ icon: pro_solid_svg_icons_1.faArrowAltRight }, iconProps)))),
                children))));
};
//# sourceMappingURL=CenteredPage.js.map